import { HostedGameApplicationsService } from '@hosted-games/infra';
import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApproveManyApplicationsPathParams, ApproveManyGamePlayerApplicationsDto } from '@core-http';

export class ApproveApplicationsCommandHandler {
  private readonly hostedGameApplicationsService: HostedGameApplicationsService = inject(HostedGameApplicationsService);

  approve(gameId: string, applicationIds: string[]): Observable<void> {
    const payload: ApproveManyGamePlayerApplicationsDto = { gamePlayerApplicationIds: applicationIds };
    const pathParams: ApproveManyApplicationsPathParams = { hostedGameId: gameId };

    return this.hostedGameApplicationsService.approveManyApplications(pathParams, payload).pipe(map(() => void 0));
  }
}
